import React from 'react';
import styles from './S3.module.css';

//Importación de videos
import video1 from './videos/Calificacion.mp4';
import video2 from './videos/Consistencia.mp4';
import video3 from './videos/Tiempo.mp4';
import video4 from './videos/Personalizacion.mp4';
import video5 from './videos/Eficiencia.mp4';
import video6 from './videos/Sesgos.mp4';

const Seccion3 = () => {
    return (
        <div className={styles.contenedor}>
            <h1 className={styles.heading}>Beneficios</h1>
            {/* Columna Izquierda */}
            <div className={`${styles.columna} ${styles.columnaIzquierda}`}>
                <div className={styles.cuadro}>

                    <video
                        className={styles.videoContenedor}
                        src={video1}
                        autoPlay
                        loop
                        muted
                        playsInline
                        onClick={(e) => e.preventDefault()} // Prevenir pausa al hacer clic
                    />
                    <div className={styles.textoContenedor}> Calificación Objetiva </div>
                </div>

                <div className={styles.cuadro}>

                    <video
                        className={styles.videoContenedor}
                        src={video2}
                        autoPlay
                        loop
                        muted
                        playsInline
                        onClick={(e) => e.preventDefault()} // Prevenir pausa al hacer clic
                    />
                    <div className={styles.textoContenedor}> Consistencia </div>
                </div>
                <div className={styles.cuadro}>
                    <video
                        className={styles.videoContenedor}
                        src={video3}
                        autoPlay
                        loop
                        muted
                        playsInline
                        onClick={(e) => e.preventDefault()} // Prevenir pausa al hacer clic
                    />
                    <div className={styles.textoContenedor}> Ahorro de Tiempo </div>
                </div>

                <div className={styles.cuadro}>
                    <video
                        className={styles.videoContenedor}
                        src={video4}
                        autoPlay
                        loop
                        muted
                        playsInline
                        onClick={(e) => e.preventDefault()} // Prevenir pausa al hacer clic
                    />
                    <div className={styles.textoContenedor}> Hiper-personalización </div>
                </div>

                <div className={styles.cuadro}>
                    <video
                        className={styles.videoContenedor}
                        src={video5}
                        autoPlay
                        loop
                        muted
                        playsInline
                        onClick={(e) => e.preventDefault()} // Prevenir pausa al hacer clic
                    />
                    <div className={styles.textoContenedor}> Eficiencia </div>
                </div>

                <div className={styles.cuadro}>

                    <video
                        className={styles.videoContenedor}
                        src={video6}
                        autoPlay
                        loop
                        muted
                        playsInline
                        onClick={(e) => e.preventDefault()} // Prevenir pausa al hacer clic
                    />
                    <div className={styles.textoContenedor}> Reducción de Sesgos </div>
                </div>
            </div>
        </div>
    );
};

export default Seccion3;
